<template>
    <split-pane  :min-percent='10' :default-percent='12' split="vertical" style="background:white; height:100%">
        <template slot="paneL" >
            <div style="display:flex;flex-direction:column;overflow-y:auto;height:90vh; background:white" > 
                <template v-for="(item, index) in menuList" > 
                    <div  class="oneMenu" :key="index" ><i class="iconfont icon-caiwuguanli1" style="margin-right:7px;"></i>{{ $LANG('1024', '锚定货币') }}  </div>
                    <template v-for="(subitem ) in item.subs">
                        <span :key="subitem.frmurl"  v-if="openName.indexOf(item.subno)>-1">
                            <div  class="twoMenu">
                                <span  :class="{active: active===subitem.frmurl}" @click="itemClick(subitem.frmurl )">
                                    <i class="iconfont icon-xiayiye1" style="font-size:10px;margin-right:5px;"></i>
                                    {{subitem.cname}} 
                                </span>
                            </div>
                        </span>
                    </template>
                </template>  
            </div>
        </template>
        <template slot="paneR">        
            <div style=" display:flex; width:100%; background:#fff;line-height:30px;border-bottom:2px solid #389;padding-top:3px">
                <div style="min-width:1100px;display:flex">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:12px;margin-right:15px;">{{ $LANG('0095', '新增记录') }}</span></el-link>
                    <i class="iconfont icon-fuzhi" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:15px;"></i>
                    <el-link :disabled="addBool" @click="cpRec" :underline="false" ><span style="font-size:12px;margin-right:15px;">{{ $LANG('1223', '复制月份记录') }}</span></el-link>
                    <i class="iconfont icon-fuzhi" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:15px;"></i>
                    <el-link :disabled="addBool" @click="cpYearRec" :underline="false" ><span style="font-size:12px;margin-right:15px;">{{ $LANG('1222', '复制年份记录') }}</span></el-link>
                    
                    <el-select v-model="selparam"  :placeholder="$LANG('1675', '请选择列名')" clearable size="small" style="width:150px;margin-left:20px; ">
                        <span v-for="item in tabCol" :key='item.key'>
                            <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                        </span>
                    </el-select>
                    <el-input :placeholder="$LANG('1692', '请输入查询值')" v-model="txtparam" @keyup.native.enter="qryTabData" size="small" style="width:310px ;height:30px;  ">
                        <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                            <span v-for="item in operArr" :key='item.IDSEQ'>
                                <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                            </span>
                        </el-select>
                        <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                    </el-input> 
                    <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                    <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
                    <!-- <el-select v-model="selparam2"  :placeholder="$LANG('1675', '请选择列名')" clearable size="small" style="width:150px;  ">
                        <span v-for="item in tabCol" :key='item.key'>
                            <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                        </span>
                    </el-select>
                    <el-input :placeholder="$LANG('1692', '请输入查询值')" @keyup.native.enter="qryTabData" v-model="txtparam2" size="small" style="width:310px ;height:30px; ">
                        <el-select v-model="oper2" slot="prepend"   style="width:100px; " >
                            <span v-for="item in operArr" :key='item.IDSEQ'>
                                <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                            </span>
                        </el-select>
                        <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                    </el-input> -->
                </div>
            </div> 
            <div style="width:100%">
                <ve-table :columns="vueCol" 
                        :table-data="tabData" 
                        style="margin-top:2px; "
                        :border-around="true"
                        :border-x="true" 
                        :border-y="true" 
                        :fixed-header="true"
    
                        row-key-field-name="IDSEQ"
                        :row-style-option="rowStyleOption"
                        :cell-style-option="cellStyleOption"
                        :max-height="tabHeight" 
                        :virtual-scroll-option="virtualScrollOption"
                        :scroll-width="0"
                        :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                        :column-width-resize-option="columnWidthResizeOption"
                        :cellSelectionOption="{enable: false,}"
                        id="crcy_load"
                        ref="tableRef"
                    >
    
                </ve-table>
                <!-- <div style="margin-top:2px">
                    <ve-pagination
                        :total="dataCount"
                        :page-index="pageIndex"
                        :page-size="pageSize"
                        :page-size-option="pageList"
                        @on-page-number-change="pageNumberChange"
                        @on-page-size-change="pageSizeChange"
                    />
                </div> -->
            </div>
 
                <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="drawer" width="1200px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
                    </div> 
                    <div style=" overflow-y:auto">
                        <Form :model="perRow" :label-width="120"  label-position="right" inline  :rules="ruleValidate">  
                            <span v-for="(item,index) in tabCol" :key="index" >
                                <FormItem  :label="$translate.getColTitle(item, $store.state.lang)"  :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">
                                    <el-date-picker :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="perRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                    <el-input-number :disabled="saveFlag"  v-else-if="item.edcss==='number'" v-model="perRow[item.key]" style="width:100%" ></el-input-number>   
                                    <el-checkbox border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="perRow[item.key]" style="width:100%"></el-checkbox> 
                                    <el-select :disabled="saveFlag" v-else-if="item.edcss==='select'" v-model="perRow[item.key]"   style="width:100%">
                                        <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                                    </el-select>
                                    <el-select :disabled="saveFlag" filterable v-else-if="item.key==='YRMTH'" v-model="perRow[item.key]"   style="width:100%">
                                        <el-option v-for="(item,index) in mthArr" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                                    </el-select>
                                    <el-input  type="text" v-else :disabled="item.disabled==='Y'?true:false||saveFlag "  v-model="perRow[item.key]"></el-input>
                                </FormItem>
                            </span>
                        </Form>
 
                    </div>
                    <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">   
                        <span style="float:right">
                            <span :style="stfgColor">
                                <i class="iconfont" :class="stfgCss"  style="font-size:30px; margin-right:40px;height:35px;vertical-align:middle"></i>
                            </span>
                            <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="drawer=false" style="margin-right:50px;">{{ $LANG('0132', '取消') }}</el-button>
                            <el-button type="primary" size="small" icon="iconfont icon-baocun"  :disabled="saveFlag?true:false" @click="saveRec" style="margin-right:10px;">{{ $LANG('0130', '保存') }}</el-button>
                        </span>
                    </div>
                </el-dialog>
                <!-- 提示框 -->
                <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
                    </div>
                    <div style="line-height:30px;display:flex">
                        <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                        <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
                    </div>
                    <span slot="footer"  >
                        <el-button type="primary" size="small" @click="promptWin = false">{{ $LANG('1638', '确 定') }}</el-button>
                    </span>
                </el-dialog>
                <!-- 复制记录 -->
                <el-dialog :visible.sync="cpWin" v-dialogDrag width="530px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1223', '复制月份记录') }}</span>
                    </div> 
                    <div style="line-height:40px;display:flex">
                        <div style="width:100px" >{{ $LANG('0491', '源月份') }}</div>
                        <el-select  v-model="frmth"  style="width:100%" filterable :placeholder="$LANG('1664', '请选择')">
                            <el-option v-for="(item,index) in mthArr " :key="index"  :value="item.CODE" :label="item.CNAME" ></el-option>
                        </el-select> 
                    </div>
                    <div style="line-height:40px;display:flex;margin-top:20px">
                        <div style="width:100px" >{{ $LANG('1083', '复制到月份') }}</div>
                        <el-select  v-model="tomth"  style="width:100%" filterable :placeholder="$LANG('1664', '请选择')">
                            <el-option v-for="(item,index) in mthArr " :key="index"  :value="item.CODE" :label="item.CNAME" ></el-option>
                        </el-select>
                    </div>
                    <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:15px ">
                        <span style="float:right">
                            <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="cpWin=false" style="margin-right:50px;">{{ $LANG('0132', '取消') }}</el-button>
                            <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="cpOk" style="margin-right:10px;">{{ $LANG('1638', '确定') }}</el-button>
                        </span>
                    </div>
                </el-dialog>

                <el-dialog :visible.sync="yearWin" v-dialogDrag width="530px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1222', '复制年份记录') }}</span>
                    </div> 
                    <div style="line-height:40px;display:flex">
                        <div style="width:100px" >{{ $LANG('0490', '源年份') }}</div>
                        <el-select  v-model="v_fryear"  style="width:100%" filterable :placeholder="$LANG('1664', '请选择')">
                            <el-option v-for="(item,index) in yrArr " :key="index"  :value="item.CODE" :label="item.CNAME" ></el-option>
                        </el-select> 
                    </div>
                    <div style="line-height:40px;display:flex;margin-top:20px">
                        <div style="width:100px" >{{ $LANG('1082', '复制到年份') }}</div>
                        <el-select  v-model="v_toyear"  style="width:100%" filterable :placeholder="$LANG('1664', '请选择')">
                            <el-option v-for="(item,index) in yrArr " :key="index"  :value="item.CODE" :label="item.CNAME" ></el-option>
                        </el-select>
                    </div>
                    <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:15px ">
                        <span style="float:right">
                            <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="yearWin=false" style="margin-right:50px;">{{ $LANG('0132', '取消') }}</el-button>
                            <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="yearOk" style="margin-right:10px;">{{ $LANG('1638', '确定') }}</el-button>
                        </span>
                    </div>
                </el-dialog>
                <VeColumnConfigDialog
                    :visible="fieldSettingDialog.visible"
                    :rows="fieldSettingDialog.rows"
                    :loading="fieldSettingDialog.loading"
                    :error="fieldSettingDialog.error"
                    :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
                    :drag-group-field="fieldSettingDialog.dragGroupField"
                    :language="$store.state.lang"
                    @update:visible="fieldSettingDialog.visible = $event"
                    @change="updateFieldSettingsDraft"
                    @confirm="saveFieldSettingsDialog"
                    @reset="resetFieldSettingsDialog"
                    @close="closeFieldSettingsDialog"
                />
        </template>
    </split-pane>
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import {getDate} from '../../api/Select' 
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
//局部注册
export default {
    name:"bs_crcy",
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '4265',
            fieldIdseq: '4265',
            fieldLstseq: '1',
            mainColumnKey: 'tabCol',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tableRef',
        })
    ],
    data () {
        return {
            v_fryear:'',
            v_toyear:'',
            yearWin:false,
            drawer:false,
            perFlag:'create',
            mthArr:[],
            yrArr:[],
            saveFlag:false,
            promptWin:false,
            prompt:'',
            stfgCss:'',
            perWin:false,
            stfgColor:'',
            perRow:{},
            menuList: [],
            openName:[], //模块ID集合
            cpWin:false,
            frmth:'',
            tomth:'',
            active:'', //二级菜单选中标志
 
            disabled:false, //新增权限制
 
            ruleValidate:{},
 
            tabData:[], //表数据
            tabCol:[], //表列 
            initCol:[],
            operArr:[],
            comboArr:{},
            oper:'like',
            txtparam:'',
            selparam:'CRCYNM',
            oper2:'like',
            txtparam2:'',
            selparam2:'YRMTH',
            delArr:[],
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            dataCount:0,
            rowSize:20,
            goPage:'',
            notNull:[],
            current:1,
            imgSrc:'',
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            rowStyleOption: {
                clickHighlight: true,
                
            },
            cellStyleOption: {
                bodyCellClass: ({ row, column, rowIndex }) => {
                    return "table-body-cell-class1" 
                },
                headerCellClass: ({column, rowIndex }) => {
                    if (column.field=='#'){
                        return "table-head-cell-class2"
                    }else{
                        return "table-head-cell-class" 
                    }
                },
            },
            virtualScrollOption: { enable: false },
            v_inputrow:{},
            v_row:{},
            loadingInstance: null,
            v_sort:'asc',
            startRowIndex: 0,
            vueCol:[],
        }
    },
    mounted () { 
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        getBaseData('xuper_auth/getBaseData','','','','','V_YRMTH','').then(res=>{
            this.mthArr =res.result
        })
        getBaseData('xuper_auth/getBaseData','','','','','V_YEAR','').then(res=>{
            this.yrArr =res.result
        })
        //用户表单新增、编辑、审核、作废权限  
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','4265','v_sys_user_priv','').then(res=>{           
            let row =res.result[0]
            if (row.ISADD==='N'){ //新增
                this.addBool=true
            }if (row.ISUPD==='N'){ //修改
                this.editBool=true
            }if (row.ISDEL==='N'){ //删除
                this.delBool=true
            }if (row.ISCFM==='N'){ //审核
                this.cfmBool=true
            }if (row.ISCANCEL==='N'){ //下推
                this.cancelBool=true
            } 
 
        }) 
        //表单所以下拦框动态赋值
        this.comSelect()
 
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4265','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =this.$translate.getColTitle(item, this.$store.state.lang)
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空')}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
        this.getCrcyList(' and bscrcy=\''+this.active+'\'')
    },
    computed: {
        editHeight: function() {
            return (window.innerHeight - 300) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 130) + 'px';
        }, 
    },
    components: {
        VeColumnConfigDialog,
    },
    destroyed() {
        this.loadingInstance.destroy()
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.loadingInstance = this.$veLoading({
                target: document.querySelector("#crcy_load"),
                name: "wave",
            })
            this.getTabField() //表列字段
            this.getMenuList()
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {

        enterDown(event){
            if (event.keyCode==13){
                this.qryTabData()
            }
        },
        inputChg(e,column){
            this.v_inputrow[column]=e.target.value
            this.v_row[column] =e.target.value
        },
        cpRec(){
            this.cpWin =true
        },
        cpYearRec(){
            this.yearWin =true
        },
        cpOk(){
            let cond_=''
            if (!this.frmth ){
                this.prompt=this.$LANG('1699', '请选择源月份')
                this.promptWin=true
            }else if (!this.tomth ){
                this.prompt=this.$LANG('1753', '请选择复制到月份')
                this.promptWin=true
            }else if (this.frmth ==this.tomth){
                this.prompt=this.$LANG('1269', '月份不同相同')
                this.promptWin=true
            }else{
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/copyData',
                    data: {p_fridseq:this.frmth,p_toidseq:this.tomth, corpid:this.v_corpid,p_oper:'CRCY'},
                }).then(res=>{ 
                    this.cpWin =false
                    this.qryTabData()
                })              
            }
        },
        yearOk(){
            if (!this.v_fryear ){
                this.prompt=this.$LANG('1698', '请选择源年份')
                this.promptWin=true
            }else if (!this.v_toyear ){
                this.prompt=this.$LANG('1752', '请选择复制到年份')
                this.promptWin=true
            }else if (this.v_fryear ==this.v_toyear){
                this.prompt=this.$LANG('1237', '年份不同相同')
                this.promptWin=true
            } else{
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/copyData',
                    data: {p_fridseq:this.v_fryear,p_toidseq:this.v_toyear, corpid:this.v_corpid,p_oper:'CRCY_YEAR'},
                }).then(res=>{ 
                    this.yearWin =false
                    this.qryTabData()
                })              
            }
        },
        //表行点击事件
        rowClick(row){
            if (row['STFG']==='Y')  {
                this.stfgColor='color:green'
                this.stfgCss='icon-yishenhe1'
            }else if (row['STFG']==='X')  {
                this.stfgColor='color:red'
                this.stfgCss='icon-yizuofei'
            }else{
                this.stfgColor='color:gray'
                this.stfgCss='icon-weishenhe3'
            }
 
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'4265',p_key2:'lstseq',p_value2:'1',p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //保存记录
        saveRec(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+' like \'%' + this.txtparam+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam +this.oper+'\''+this.txtparam+'\''
                }
            }
            if (this.selparam2){ //列1
                if (this.oper2==='like'){
                    cond_=cond_+' and '+this.selparam2+' like \'%' + this.txtparam2+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam2 +this.oper2+'\''+this.txtparam2+'\''
                }
            }
            var vm =this 
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.perRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=this.$translate.getColTitle(item, this.$store.state.lang)+this.$LANG('2051', '不能为空')
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool) {  
                // if (this.perRow['CRCY']==this.perRow['BSCRCY'])  {
                //     this.promptWin =true
                //     this.prompt ='货币和锚定货币不能相同'
                // }else{
                    let obj_ ={}      
                    Object.assign(obj_,vm.perRow,{ 'CORPID':this.v_corpid}) 
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(obj_), p_table:'bs_crcy'},
                    }).then(res=>{      
                        if(res.result ==='OK')  {  
                            vm.drawer =false   
                            this.getCrcyList(' and bscrcy=\''+this.active+'\''+cond_)
                        }else{
                            if (res.result.indexOf('ORA-00001')){
                                this.prompt=this.$LANG('0797', '已存在相同月份的记录')
                            }else{
                                this.prompt=res.result
                            }
                            this.promptWin=true                       
                        }        
                    }) 
               // }
            }
        },
        //状态审核
        recSet(row,val){
            let stfg_ =val==='Y'?this.$LANG('0134', '审核'):val==='N'?this.$LANG('0137', '弃审'):this.$LANG('0257', '作废')
            this.$confirm(this.$LANG('1564', '你确定要')+stfg_+this.$LANG('1566', '此行记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                let cond_=''
                if (val==='Y'){
                    cond_=' set stfg=\''+val+'\',cfmdttm=\''+getDate('date')+'\' '
                }else{
                    cond_=' set stfg=\''+val+'\',cfmdttm=null ' 
                }
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ ,p_table:'BS_crcy',p_cond:cond_ },
                }).then(res=>{      
                    if(res.code =='200')  {           
                        vm.qryTabData()     
                    }else{
                        this.promptWin=true
                        this.prompt=res.message
                    }        
                }) 
                 
            }).catch(()=>{})
        },
        //货币明细
        getCrcyList(cond){
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'', p_value:'',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+ ' order by crcy,yrmth desc',p_table:'V_BS_Crcy'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.tabData =res.result
 
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
                this.$nextTick(() => { //有固定列时 查询后重新布局
                     
                })
            }) 
        },
 
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                if (row.STFG==='N'){
                    this.saveFlag=false
                }else{
                    this.saveFlag=true
                }
            }
            this.perRow =JSON.parse(JSON.stringify(row))
            this.drawer=true           
        },
        getRowKey(row){
            return row.PKSEQ
        },
        //查询
        qryTabData(){
            let v_cond=' and 1=1 ' ,v_oper='' ,v_edcss=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    v_cond=v_cond+' and '+this.selparam+' like \'%' + this.txtparam+'%\''
                }else{
                    v_cond=v_cond+' and '+this.selparam +this.oper+'\''+this.txtparam+'\''
                }
            }
            Object.keys(this.v_row).filter(item=>item.indexOf('#OPER')<0).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (this.v_row[`#OPER`+item]){
                        v_oper =this.v_row[`#OPER`+item]
                    }
                    if (!v_oper){
                        v_oper ='like'
                    }
                    if (v_oper =='like'){
                        v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                    }else{
                        if (v_edcss =='number' ){
                            v_cond =v_cond +' and '+item+ v_oper +  this.v_row[item] 
                        }else if ( v_edcss=='date'){
                            v_cond =v_cond +' and substr('+item+',1,10)'+ v_oper +'\''+this.v_row[item] +'\''          
                        }else{
                            v_cond =v_cond +' and lower('+item+')'+v_oper+'\''+ (this.v_row[item]).toLowerCase().trim()+'\''  
                        }
                    }
                }
            })
            this.getCrcyList(' and bscrcy=\''+this.active+'\''+ v_cond)
             
        },
        sortChange(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            } 
            this.tabCol.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.tabData.sort((a, b) => {
                if (v_edcss =='number' ){
                    let nameA = a[v_key]?a[v_key]:0 
                    let nameB = b[v_key]?b[v_key]:0 
                    if (this.v_sort =='asc'){
                        return nameA -nameB
                    }else if (this.v_sort =='desc'){
                        return nameB -nameA
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]?a[v_key].toUpperCase():a[v_key]  
                    let nameB = b[v_key]?b[v_key].toUpperCase():b[v_key]     
                    if (this.v_sort =='asc'){
                        if (nameA > nameB) {
                            return -1
                        }else{
                            return 1
                        }
                    }else{
                        if (nameA > nameB) {
                            return 1
                        }else{
                            return -1
                        }
                    }
                }
            })
        },
        //新增 
        addRec(){
            // getBaseData('xuper_auth/getBaseData','corpid',this.v_corpid ,'stfg','N','V_BS_CRCY','').then(res=>{           
            //     if (res.result.length>0) {
            //         this.promtWin=true
            //         this.prompt='有未审核记录时不能新增,请先审核'
            //     }else{
                    this.drawer =true
                    this.stfgCss='icon-weishenhe3'
                    this.perRow={BSCRCY:this.active,STFG:'N'}
                    this.saveFlag=false
            //     }
            // })           
        },
        //删除记录
        delRec(row,index){
                this.$confirm(this.$LANG('1564', '你确定要')+this.$LANG('0131', '删除')+this.$LANG('1566', '此行记录吗'),this.$LANG('1442', '提示'),{
                    confirmButtonText: this.$LANG('1638', '确定'),
                    cancelButtonText:this.$LANG('0132', '取消'),
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    //发起删除请求
                    var vm=this;
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/delTabRec',
                        data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'bs_crcy'},
                    }).then(res=>{      
                        if(res.code =='200')  {           
                            //this.getCrcyList(' and bscrcy=\''+this.active+'\'' )  
                            this.tabData.splice(index,1)
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                        }        
                    })     
                }).catch(()=>{})
        },
        //左边菜单
        getMenuList(){
            this.$axios({
                method:'post',
                url: 'xuper_auth/getSubList' ,
                data:{maintab:'V_SUPTY',p_key:'CODE',p_value:'4237',subtab:'V_SUPTYITM'},
            }).then(res =>{
                this.menuList =res.result
                //初始化选中第一个
                this.active =res.result[0].subs[0].frmurl
                this.queryEvent( this.active)
                for (let k=0;k<res.result.length;k++){
                    this.openName.push(res.result[k].subno)
                } 
            })
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
                this.v_inputrow={}
            })
 
            this.qryTabData()
        } ,
        queryEvent( frmurl){
           this.getCrcyList(' and bscrcy=\''+frmurl+'\'')
             
        },
        //二级菜单点击事件
        itemClick(frmurl ){
            this.active =frmurl
            this.queryEvent( frmurl)
        },
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4265','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                vm.initCol =res.result
                return vm.loadInitialFieldSettings().then(() => {
                    let fieldRows =vm.sortFieldRows(vm.initCol)
                for (let k=0; k<fieldRows.length; k++){
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(fieldRows[k], vm.$store.state.lang),
                        key: fieldRows[k].key,
                        align: fieldRows[k].align,
                        width: fieldRows[k].width,
                        thide:fieldRows[k].THIDE,
                        fhide:fieldRows[k].FHIDE,
                        edcss:fieldRows[k].EDCSS,
                        disabled:fieldRows[k].DISABLED,
                    })
                    let itcol =fieldRows[k]
                    if (itcol.THIDE=='N'){
                        let v_obj ={   //向数组的开头 添加序列号
                            field:itcol['key'] ,
                            title: vm.$translate.getColTitle(itcol, vm.$store.state.lang),
                            key: itcol['key']  ,
                            type:itcol.EDCSS=='checkbox'?'check':itcol.EDCSS,
                            align: itcol.align,                                
                            width: Number(itcol.width),
                            thide:itcol.THIDE,
                            fhide:itcol.FHIDE,
                            sortable:false,
                            renderHeaderCell: ({column}, h) => {
                                if (itcol.EDCSS =='date'||itcol.EDCSS =='time') {
                                    return (                              
                                        <div >                   
                                            <div style="margin-top:3px;display:flex;white-space: nowrap;  " >
                                                <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700">{column.title}</el-link>                                            
                                            </div> 
                                            <div style="display:flex">
                                                <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_inputrow[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>
                                                    <option  selected value="like" style="height:30px;line-height:30px">like</option>
                                                    <option    value="=" style="height:30px;line-height:30px">=</option>
                                                    <option    value=">" style="height:30px;line-height:30px">&gt;</option>
                                                    <option    value="<" style="height:30px;line-height:30px">&lt;</option>
                                                    <option    value="!=" style="height:30px;line-height:30px">!=</option>
                                                </select>
                                                <input  size="mini" pattern="yyyy-MM-dd"  value={this.v_inputrow[column.key]} type="date" on-keydown={()=>this.enterDown(event)} on-input={(e)=>{this.inputChg(e,column.key)}} style="padding:0px;margin-top:1px;width:100%;height:28px"> </input>              
                                            </div>
                                        </div>                                   
                                    )
                                }else{
                                    return (                              
                                        <div >
                                            <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>
                                                
                                            </div>                        
                                            <div style="display:flex">
                                                <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_inputrow[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>
                                                    <option  selected value="like" style="height:30px;line-height:30px">like</option>
                                                    <option    value="=" style="height:30px;line-height:30px">=</option>
                                                    <option    value=">" style="height:30px;line-height:30px">&gt;</option>
                                                    <option    value="<" style="height:30px;line-height:30px">&lt;</option>
                                                    <option    value="!=" style="height:30px;line-height:30px">!=</option>
                                                </select>
                                                <input  placeholder=""  disabled={itcol.EDCSS=='image'}  value={this.v_inputrow[column.key]} on-keydown={()=>this.enterDown(event)}  on-input={(e)=>{this.inputChg(e,column.key)}} style="padding:0px;margin-top:1px;width:100%;height:28px" size="mini"></input>
                                            </div>
                                        </div>                                   
                                    )
                                }
                            },
                            disabled:itcol.DISABLED,
                            ellipsis: { showTitle: true, },
                            renderBodyCell: ({row,column,rowIndex},h) => {
                                let  rowVal =row[itcol['key'] ]
                                if (itcol.EDCSS=='image' ){
                                    return ( 
                                        <el-image fit="scale-down"  style="width:100%;height:30px; " src={rowVal} preview-src-list={[rowVal]}>
                                            <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                                        </el-image>
                                    )
                                } else if (column.key=='STFG') {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('1952', '有效')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('1951', '无效')}</el-tag> )
                                    }  
                                        
                                }else{
                                    return row[itcol['key'] ]
                                }
                            },                                
                        }
                        this.vueCol.push(v_obj)
                    }
                }
                // 分组 字段
                let v_rownum ={
                    field: "index",
                    key: "rownum",
                    title: this.$LANG('0310', '序号'),
                    width: 55,
                    align: "center",
                    fixed:"left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (<span style="color:#1890ff;">
                            {rowIndex + this.startRowIndex + 1}
                        </span> )
                    },
                    renderHeaderCell: ({column}, h) => {
                        return (  
                            <div >
                                <div style="margin-top:3px">{column.title}</div>
                                <el-link on-click={()=>{this.rowShow()}} style="font-size:12px;color:#404eff;height:30px"> 
                                    <el-tooltip content={this.$LANG('0852', '清除条件')} effect="light">
                                        <i class="iconfont icon-shanchu1"  ></i>
                                    </el-tooltip>
                                </el-link>
                            </div>
                        )
                    },
                }
                let v_oper ={
                    field: "oper0",
                    key: "oper",
                    title: this.$LANG('0330', '操作'),
                    width:165,
                    align: "center",
                    fixed:"right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ( 
                            <div>
 
                                <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link  on-click={()=>{this.editRec(row,'Y',rowIndex)}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                                <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link  disabled={this.editBool} on-click={()=>{this.editRec(row,'N',rowIndex)}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('1639', '编辑')}</span></el-link>
                                <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link  disabled={this.cancelBool} on-click={()=>{this.delRec(row,rowIndex)}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0131', '删除')}</span></el-link>
 
                            </div>                                
                        )
    
                    },
                }
                this.vueCol.unshift(v_rownum) 
                this.vueCol.push(v_oper)
                vm.applyFieldSettingRows()
                return res
                })
            })
 
        }
    }
}
</script>
<style scoped lang="less">
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .oneMenu{
        line-height:35px;
        text-align:left;
        padding-left:35px;
        font-size:14px;
        color:white;
        background-color: #808695;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#f4f6f8;
    }
    .twoMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        padding-left:35px;
 
    }
    .twoMenu:hover{
        cursor: pointer;
        color:#409EFF;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
    .el-header  {
        background-color: #fff;
        color: #409EFF;
        text-align: center;
        line-height: 60px;
        width:100%;
    }
  .el-main {
    background-color: #fff;
    color: rgb(207, 206, 206);
    text-align: center;
    height:100%;
  }
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .table-head-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        padding:0px !important;
        padding-top:4px !important;
        text-align:center !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    .table-head-cell-class2 {
        font-size: 12px !important;
        color: rgb(134, 4, 4) !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        border-width: 1px !important;
        border-color: #808695 !important;
        padding:6px !important;
    }
    .table-body-cell-class1 {
        font-size: 12px !important;
        color: black !important;
        border-width: 1px !important;
        padding:2px !important;
        border-color: #808695 !important;
        height:20px !important;
    }
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table__body {
        width: 100%;
        // 使表格兼容safari，不错位
        table-layout: fixed !important;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
